import { render, staticRenderFns } from "./LatestEvents.vue?vue&type=template&id=7f857f6a&scoped=true"
import script from "./LatestEvents.vue?vue&type=script&lang=js"
export * from "./LatestEvents.vue?vue&type=script&lang=js"
import style0 from "./LatestEvents.vue?vue&type=style&index=0&id=7f857f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f857f6a",
  null
  
)

export default component.exports